module.exports = __webpack_public_path__ + "static/media/ms.fda3c921.png";